export default function StructuredData() {
  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "AskTheSea",
    "alternateName": "Ask the Sea",
    "url": "https://askthesea.com/"
  };

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": "https://askthesea.com/#organization",
    "name": "AskTheSea",
    "alternateName": "Ask the Sea",
    "url": "https://askthesea.com/",
    "logo": {
      "@type": "ImageObject",
      "url": "https://askthesea.com/logo.png"
    }
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(websiteSchema)
        }}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(organizationSchema)
        }}
      />
    </>
  );
}
